<template>
  <div class="record-con" :class="{ 'large-font-mode': pageData.largeFontMode }">
    <!--  头部 start  -->
    <div class="header-con flex flex-row align-center w-full">
      <span class="date">{{ info.diagTime|DateTimeToDate }}</span>
      <el-tag size="small">{{ info.storeUserName }}</el-tag>
    </div>
    <!--  头部 end  -->
    <div class="body-con flex flex-col" :class="{ 'large-font-mode': pageData.largeFontMode }">
      <!--   诊断记录 start   -->
      <div class="record-item flex flex-col">
        <div class="label-con flex flex-row align-center">
          <div class="icon" />
          <span class="label">诊断记录</span>
        </div>
        <div class="content flex flex-col background-gary">
          <div class="item flex flex-row align-center mb-8">
            <div class="label">主诉</div>
            <div class="value">{{ info.symContent }}</div>
          </div>
          <!-- <div class="item flex flex-row align-center mb-8">
            <div class="label">现病史</div>
            <div class="value">{{ info.symContent }}</div>
          </div> -->
          <div class="item flex flex-row align-center mb-8">
            <div class="label">四诊</div>
            <div class="value">{{ info.fdmContent }}</div>
          </div>
          <div class="item flex flex-row align-center mb-8">
            <div class="label">中医诊断</div>
            <div class="value">{{ info.chYndromeContent + " " + info.chDiagContent }}</div>
          </div>
          <div class="item flex flex-row align-center">
            <div class="label">西医诊断</div>
            <div class="value">{{ info.diagContent }}</div>
          </div>
        </div>
      </div>
      <div class="record-item flex flex-col">
        <div class="label-con flex flex-row align-center">
          <div class="icon" />
          <span class="label">体格记录</span>
        </div>
        <div class="content flex flex-col background-gary">
          <div class="item flex flex-row align-center mb-8">
            <div class="label">体温</div>
            <div class="value">{{ info.temperature }}</div>
          </div>
          <div class="item flex flex-row align-center mb-8">
            <div class="label">血压</div>
            <div class="value">{{ info.lowPressure +'/'+info.highPressure }}</div>
          </div>
          <div class="item flex flex-row align-center mb-8">
            <div class="label">血糖</div>
            <div class="value">{{ info.bloodSugar }}</div>
          </div>
        </div>
      </div>
      <!--   诊断记录 end   -->
      <!--   治疗 start   -->
      <div class="record-item flex flex-col">
        <div class="label-con flex flex-row align-center justify-between">
          <div class="flex flex-row align-center">
            <div class="icon" />
            <div class="label">治疗</div>
          </div>
          <el-button
            :disabled="copyBtnDisabled || ['2'].indexOf( pageData.activeDiagRecord.diagRecord.stateSign)===-1"
            type="primary"
            size="small"
            @click="copyTreatment"
          >复制
          </el-button>
        </div>
        <div class="content w-full">
          <!--     tab区 start     -->
          <div class="head-con flex flex-row align-center justify-between w-full">
            <div class="tab-con w-full">
              <el-tabs v-model="activeTab" tab-position="left" @tab-click="handleTabChange">
                <el-tab-pane label="饮片处方" name="1">
                  <treatment-record
                    ref="chmed"
                    url="clinic/treatment/treatment/chmedprescription"
                    @command="handleTreatmentCommand"
                  />
                </el-tab-pane>
                <el-tab-pane label="中成药处方" name="2">
                  <treatment-record
                    ref="med"
                    med-code="medPrescriptionItem"
                    url="clinic/treatment/treatment/medprescription"
                    @command="handleTreatmentCommand"
                  />
                </el-tab-pane>
                <el-tab-pane label="理疗处方" name="3">
                  <treatment-record
                    ref="liliaomed"
                    med-code="servePrescriptionItem"
                    url="clinic/treatment/treatment/serveprescription"
                    @command="handleTreatmentCommand"
                  />
                </el-tab-pane>
                <el-tab-pane label="代煎处方" name="4">
                  <treatment-record
                    ref="djmed"
                    med-code="chagentPrescriptionItem"
                    url="pharmacy/storage/agentpre/chagentprescription"
                    @command="handleTreatmentCommand"
                  />
                </el-tab-pane>
                <el-tab-pane label="代售处方" name="5">
                  <treatment-record
                    ref="dsmed"
                    med-code="agentPrescriptionItem"
                    url="pharmacy/storage/agentpre/agentprescription"
                    @command="handleTreatmentCommand"
                  />
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
          <!--     tab区 end     -->
        </div>
      </div>
      <!--   治疗 end   -->
    </div>
  </div>
</template>
<script>
import TreatmentRecord from "@/views/business/page/treatment/treatment/diagnosisRecord/TreatmentRecord.vue"
import { findAll } from "@/api/ik/data/dataApi"
import dayjs from "dayjs"

export default {
  name: "DiagnosisRecord",
  components: {
    TreatmentRecord
  },
  inject: ["pageData"],
  filters: {
    DateTimeToDate(datetime) {
      return dayjs(datetime).format('YYYY-MM-DD')
    }
  },
  props: {
    record: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      activeTab: "1",
      treatmentId: "",
      info: {},
      copyBtnDisabled: false
    }
  },
  created() {
    this.getHisTreatment()
  },
  methods: {
    /**
     * tab切换
     * @param val
     */
    handleTabChange(val) {
      switch (val.name) {
        case "1":
          this.$refs.chmed.getPrescription(this.info.id)
          break
        case "2":
          this.$refs.med.getPrescription(this.info.id)
          break
        case "3":
          this.$refs.liliaomed.getPrescription(this.info.id)
          break
        case "4":
          this.$refs.djmed.getPrescription(this.info.id)
          break
        case "5":
          this.$refs.dsmed.getPrescription(this.info.id)
          break
        default:
          break
      }
    },
    /**
     * 诊疗记录组件指令处理
     * @param command
     */
    handleTreatmentCommand(command) {
      switch (command.type) {
        case "getData":
          this.copyBtnDisabled = command.data.length === 0
          break
        default:
          break
      }
    },
    /**
     * 复制诊疗
     */
    copyTreatment() {
      switch (this.activeTab) {
        case "1":
          // 饮片处方
          this.$emit("command", { type: "copyChmed", data: this.$refs.chmed.getInfo() })
          console.log(this.$refs.chmed.getInfo())
          break
        case "2":
          // 中成药处方
          this.$emit("command", { type: "copyMed", data: this.$refs.med.getInfo() })
          break
        case "3":
          // 中成药处方
          this.$emit("command", { type: "copyServe", data: this.$refs.liliaomed.getInfo() })
          break
        default:
          break
      }
    },
    /**
     * 获取诊疗记录
     */
    getHisTreatment() {
      const bgTrPath = "clinic/treatment/treatment/treatmentrecord"
      const pd = {
        storeCode: this.pageData.storeCode,
        diagRecordCode: this.record.code
      }
      findAll(bgTrPath, pd)
        .then(res => {
          this.info = res.data[0]
          this.treatmentId = this.info.id
          this.$refs.chmed.getPrescription(this.info.id)
        })
    }
  }
}
</script>
<style scoped lang="scss">
 .large-font-mode {
  // 诊断记录项样式强化
  .record-item {
    .label-con {
      margin-bottom: 16px; // 增加标题间距
      .label {
        font-size: 20px !important;
        line-height: 30px !important;
      }
    }
    .content {
      padding: 12px 16px; // 增加内容区内边距
      .item {
        margin-bottom: 12px; // 增加项目间距
        .label {
          font-size: 18px !important;
          line-height: 28px !important;
          margin-right: 40px; // 增加标签与内容间距
        }
        .value {
          font-size: 18px !important;
          line-height: 28px !important;
        }
      }
    }
  }

  // 治疗区域样式调整
  .tab-con {
    ::v-deep .el-tabs__item {
      font-size: 16px;
      padding: 10px 20px;
    }
  }
  .el-button {
    padding: 8px 16px;
    font-size: 16px;
  }
}
.record-con {
  .header-con {
    height: 40px;
    background: #F7F8FA;
    border-radius: 0 0 0 0;
    border: 1px solid #E5E6EB;
    padding: 8px 16px;
  }

  .body-con {
    padding: 16px;
    border: 1px solid #E5E6EB;
    border-radius: 0 0 4px 4px;

    .record-item {
      margin-bottom: 16px;

      .label-con {
        margin-bottom: 12px;

        .icon {
          width: 4px;
          height: 14px;
          background: #165DFF;
          border-radius: 0 0 0 0;
          margin-right: 8px;
        }

        .label {
          font-family: PingFang SC, PingFang SC, serif;
          font-weight: bold;
          font-size: 16px;
          color: #1D2129;
          line-height: 24px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }

      .content {
        border-radius: 4px 4px 4px 4px;
        padding: 5px 12px;

        .item {
          .label {
            font-family: PingFang SC, PingFang SC, serif;
            font-weight: normal;
            font-size: 14px;
            color: #4E5969;
            line-height: 22px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            margin-right: 32px;
          }

          .value {
            font-family: PingFang SC, PingFang SC, serif;
            font-weight: normal;
            font-size: 14px;
            color: #1D2129;
            line-height: 22px;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }
        }
      }
    }
  }
}

.mb-8 {
  margin-bottom: 8px;
}
</style>
